// Author Liang Gang Qiang
// Date 2021-09-09 16:42:36

import * as model from "@/model/em/admin/EmAdmRoleTagModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAdmRoleTag(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .buildStore()
